(function () {
  function limitCardTags() {
    document.querySelectorAll(".api-cards .card-categories").forEach(function (container) {
      var tags = Array.from(container.querySelectorAll(".card-tag.card-category"));
      var existingMore = container.querySelector(".card-tags-more");
      if (existingMore) existingMore.remove();
      var existingPopover = container.querySelector(".card-tags-popover");
      if (existingPopover) existingPopover.remove();
      tags.forEach(function (tag) {
        tag.classList.remove("card-tag-hidden");
      });

      var hasInternal = tags.some(function (tag) {
        return tag.textContent.trim().toLowerCase() === "internal";
      });
      var maxVisible = hasInternal ? 4 : 3;

      if (tags.length <= maxVisible) return;

      var hiddenTags = tags.slice(maxVisible);
      var hiddenCount = hiddenTags.length;
      hiddenTags.forEach(function (tag) {
        tag.classList.add("card-tag-hidden");
      });

      var moreBtn = document.createElement("span");
      moreBtn.className = "card-tags-more";
      moreBtn.textContent = "+" + hiddenCount + " more";
      moreBtn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var existing = container.querySelector(".card-tags-popover");
        if (existing) {
          existing.remove();
          return;
        }
        var popover = document.createElement("div");
        popover.className = "card-tags-popover";
        hiddenTags.forEach(function (tag) {
          var clone = tag.cloneNode(true);
          clone.classList.remove("card-tag-hidden");
          popover.appendChild(clone);
        });
        container.appendChild(popover);
      });
      container.appendChild(moreBtn);
    });
  }

  // Close popovers on click outside
  document.addEventListener("click", function (e) {
    if (!e.target.closest(".card-tags-more") && !e.target.closest(".card-tags-popover")) {
      document.querySelectorAll(".card-tags-popover").forEach(function (p) {
        p.remove();
      });
    }
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", limitCardTags);
  } else {
    limitCardTags();
  }

  // Re-apply after cards become visible (filtering may change display)
  var observer = new MutationObserver(function (mutations) {
    var shouldReapply = mutations.some(function (m) {
      return m.type === "attributes" && m.attributeName === "style";
    });
    if (shouldReapply) limitCardTags();
  });
  var apiCards = document.querySelector(".api-cards");
  if (apiCards) {
    observer.observe(apiCards, { attributes: true, subtree: true, attributeFilter: ["style"] });
  }
})();
